import PropTypes from "prop-types"
import React from "react"

import Chips from "src/components/Chips"

import { titlecase } from "src/utils/string_helpers"

import { TRANSACTION_TYPE_MAPPING } from "./Filters"

const FilterChips = ({ table, groups }) => {
  const { filters } = table

  const chips = []

  if (filters.search) {
    chips.push({
      key: "search",
      text: `Search: ${filters.search}`,
      onClick: () => table.clearFilter("search"),
    })
  }

  if (filters.statuses?.length > 0) {
    filters.statuses.forEach((status) => {
      chips.push({
        key: `status-${status}`,
        text: `Status: ${titlecase(status)}`,
        onClick: () =>
          table.setFilter(
            "statuses",
            filters.statuses.filter((s) => s !== status)
          ),
      })
    })
  }

  if (filters.categories?.length > 0) {
    filters.categories.forEach((cat) => {
      chips.push({
        key: `category-${cat}`,
        text: `Category: ${TRANSACTION_TYPE_MAPPING[cat] ?? titlecase(cat)}`,
        onClick: () =>
          table.setFilter(
            "categories",
            filters.categories.filter((c) => c !== cat)
          ),
      })
    })
  }

  if (filters.contractGroups?.length > 0) {
    filters.contractGroups.forEach((id) => {
      chips.push({
        key: `contractGroup-${id}`,
        text: groups.find((g) => g.encodedId === id)?.name ?? id,
        onClick: () =>
          table.setFilter(
            "contractGroups",
            filters.contractGroups.filter((g) => g !== id)
          ),
      })
    })
  }

  if (filters.loaMin != null || filters.loaMax != null) {
    const min = filters.loaMin
    const max = filters.loaMax
    const text =
      min != null && max != null && min === max
        ? `Exactly ${min}'`
        : min != null && max != null
        ? `Between ${min}' – ${max}'`
        : min != null
        ? `At least ${min}'`
        : `At most ${max}'`
    chips.push({
      key: "loa",
      text,
      onClick: () => table.setFilters({ loaMin: null, loaMax: null }),
    })
  }

  if (chips.length === 0) return null

  return (
    <div className="px-4 xl:px-0">
      <Chips onReset={() => table.clearAllFilters()}>
        {chips.map((chip) => (
          <Chips.Chip key={chip.key} text={chip.text} onClick={chip.onClick} />
        ))}
      </Chips>
    </div>
  )
}

FilterChips.propTypes = {
  table: PropTypes.object.isRequired,
  groups: PropTypes.array.isRequired,
}

export default FilterChips
